import script from "./ProntuarioView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProntuarioView.vue?vue&type=script&setup=true&lang=ts"

import "./ProntuarioView.vue?vue&type=style&index=0&id=02d0ac18&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d0ac18"]])

export default __exports__